function getServerHost() {
  return "https://" + window.location.hostname + ":3001/";
}

function getClientHost() {
  //console.log("### port '" + window.location.port + "'");
  return "https://" + window.location.hostname + ":" + window.location.port + "/";
}


export { getServerHost, getClientHost };